import AppContext from '@sportnet/ui/TheLayout/AppContext';
import React, { useCallback } from 'react';
import { useParams } from 'react-router-dom';
import Api from '../../../../Api';
import Layout from '../../../../components/Layout';
import NscSyncStatus from '../../../../components/NscSyncStatus';
import { __ } from '../../../../utilities';
import Wrapper from '../index';

const NscStatus = () => {
  const { appspace } = useParams();

  const fetchStatus = useCallback(() => {
    return Api.crmMyOrganizationIssSyncStatus(appspace);
  }, [appspace]);

  return (
    <Layout>
      <AppContext title={__('Moja organizácia')} />
      <Wrapper activeTab={__('NŠC')}>
        <NscSyncStatus
          fetchStatus={fetchStatus}
          title={__('Stav synchronizácie s NŠC')}
        />
      </Wrapper>
    </Layout>
  );
};

export default NscStatus;
